var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Ozg Padding"},[_vm._v("Краткое описание «"+_vm._s(_vm.card.name_big)+"»")])])
}
var staticRenderFns = []

export { render, staticRenderFns }